import React, { Component } from 'react';
import {
    Dropdown,
    Popover,
    Tooltip as NCTooltip,
    Checkbox as NCCheckbox,
    Dnd,
    Tooltip,
} from '@platform/base';
import { getSysFieldid } from '@platform/api';
import { cloneDeep } from 'lodash';

export default class SortDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            configNamesList: [],
            dargname: '',
            currentColumnConfigIndex: -1,
            dragoverIndex: -1,
            closeColumn: true,
        };
        this.sortFieldOrign = cloneDeep(this.props.searchInfo.sortField);
    }
    //渲染完成或props进来后就拷贝一份searchInfo.sortField数据用于【恢复默认】

    checkedChange = sortItem => {
        sortItem._checked = !sortItem._checked;
        this.forceUpdate();
    };
    sortChange = (sortItem, type, e) => {
        e.stopPropagation();
        sortItem.ordertype = type;
        this.forceUpdate();
    };
    reset = () => {
        console.log(this);
        this.props.searchInfo.sortField = cloneDeep(this.sortFieldOrign);
        this.forceUpdate();
    }
    render() {
        let { configNamesList, dargname, currentColumnConfigIndex } =
            this.state;
        let { multiLang } = this.props;
        let info = this.props.searchInfo;
        let filterSortField = info.sortField;
        // let filterSortField = sortField.filter((item) => {
        //     return item.ordertype !== '0';
        // });
        if (filterSortField.length === 0) {
            return null;
        }

        const list = filterSortField.map((e, i) => {
            return (
                <div
                    refname={e.refname}
                    refcode={e.refcode}
                    key={e.refcode}
                    ordertype={e.ordertype}
                    fieldid={getSysFieldid(e.refcode)}
                    onMouseOver={() => {
                        this.setState({ currentColumnConfigIndex: i });
                    }}
                    onMouseLeave={() => {
                        this.setState({ currentColumnConfigIndex: -1 });
                    }}
                    className={`${
                        currentColumnConfigIndex === i &&
                        'sort-search-config-hover'
                    } ${this.state.dragoverIndex === i && 'sort-drag-over'} sort-drop`}
                >
                    <span className="iconfont icon-tuozhuai1 sort-serach-tuozhuai"></span>
                    {
                        <React.Fragment>
                            <span
                                title={e.refname}
                                className="refer-column-config-yincang"
                            >
                                <Tooltip
                                    placement="top"
                                    overlay={e.refname}
                                    delayHide={1}
                                    delayShow={1000}
                                    overlayStyle={{ zIndex: 2000 }}
                                >
                                    <span>{e.refname}</span>
                                </Tooltip>
                            </span>
                        </React.Fragment>
                    }
                    <span className='sort-group'>
                        <span
                            className={
                                'sort-arrow sort-up' +
                                    (e.ordertype === '1' ? ' activeIcon' : '')
                            }
                            onClick={this.sortChange.bind(this, e, '1')}
                        >
                            <i className="iconfont icon-shengxu2"></i>
                        </span>
                        <span
                            className={
                                'sort-arrow sort-down' +
                                    (e.ordertype === '2' ? ' activeIcon' : '')
                            }
                            onClick={this.sortChange.bind(this, e, '2')}
                        >
                            <i className="iconfont icon-jiangxu2"></i>
                        </span>
                        <span
                            className={
                                'sort-arrow sort-none' +
                                    (e.ordertype === '0' ? ' activeIcon' : '')
                            }
                            onClick={this.sortChange.bind(this, e, '0')}
                        >
                            <i className="iconfont icon-bupaixu"></i>
                        </span>
                    </span>
                </div>
            );
        });
        return (
        // <Dropdown
        //     trigger={['click']}
        //     placement="bottomLeft"
        //     overlay={
        //         <ul className="menu_items sort-drop">
        //             {filterSortField.map((item) => {
        //                 return <li><NCCheckbox checked={item._checked} onChange={this.checkedChange.bind(this, item)}>{item.refname}</NCCheckbox>
        //                     <span className='sort-container'>
        //                         <span className={'sort-arrow sort-up' + (item.ordertype === '1' ? ' activeIcon' : '')} onClick={this.sortChange.bind(this, item, '1')}><i class="iconfont icon-shangjiantou"></i></span>
        //                         <span className={'sort-arrow sort-down' + (item.ordertype === '2' ? ' activeIcon' : '')} onClick={this.sortChange.bind(this, item, '2')}><i class="iconfont icon-xiajiantou"></i></span>
        //                     </span>
        //                 </li>
        //             })}
        //         </ul>
        //     }
        // >
        //     <span className='sort_button'>
        //         {'排序字段'} <i className="iconfont icon-hangcaozuoxiala1" />
        //     </span>
        // </Dropdown >

            <Popover
                className={`popover-in-sortsearch coulmn-popover`}
                trigger="click"
                // trigger={['hover']}
                placement="bottomRight"
                // container={this.popover ? this.popover : null}
                // style={{ display: showColumnConfigPop ? 'unset' : 'none' }}
                // show={showColumnConfigPop}
                // onHide={() => {
                //     // if (this.flag) {
                //     //     this.flag = false;
                //     //     return;
                //     // }
                //     this.handleColumnConfigPop(false);
                // }}
                content={
                    <div fieldid={getSysFieldid('search-sort-field')}>
                        <div className="sort-search-title">
                            <span className="sort-search-title-name">
                                {multiLang[
                                    'page-search-0131'
                                ] || '列表排序设置'}
                            </span>
                            <span className="to-default" onClick={this.reset}>
                                {multiLang[
                                    'page-search-0132'
                                ] || '恢复默认'}
                            </span>
                        </div>
                        <div>
                            <Dnd
                                dragClass="sort-search-config-item"
                                dropClass="refer-dnd sort-search-config-list"
                                dragingClass="sort-search-config-item-darging"
                                // dropOverClass="refer-drag-over"
                                list={list}
                                onStart={(drag, list) => {}}
                                onStop={(drag, list) => {
                                    if (list) {
                                        //拖拽结束时把对应list的数据更新到searchInfo.sortField上
                                        let sortField = [];
                                        list.forEach(item => {
                                            sortField.push({
                                                refcode: item.props.refcode,
                                                refname: item.props.refname,
                                                ordertype: item.props.ordertype,
                                            });
                                        });
                                        this.props.searchInfo.sortField =
                                            sortField;
                                        this.setState({ dragoverIndex: -1 });
                                        this.forceUpdate();
                                    }
                                }}
                                onDragUpdate={overItem => {
                                    let { destination, source } = overItem;
                                    if (destination && destination.index) {
                                        if (
                                            source &&
                                            (source.index || source.index === 0)
                                        ) {
                                            if (
                                                source.index >=
                                                destination.index
                                            ) {
                                                this.setState({
                                                    dragoverIndex:
                                                        destination.index - 1,
                                                });
                                            } else if (
                                                source.index < destination.index
                                            ) {
                                                this.setState({
                                                    dragoverIndex:
                                                        destination.index,
                                                });
                                            }
                                        }
                                    }
                                }}
                                fieldid="sort-search_list"
                            />
                        </div>
                    </div>
                }
            >
                <Tooltip
                    placement="top"
                    overlay={multiLang[
                        'page-search-0133'
                    ] || '查询字段排序'}
                    delayHide={1}
                    delayShow={1000}
                >
                    <div key="5">
                        <span
                            fieldid={getSysFieldid('sort_btn')}
                            ref={dom => {
                                this.shezhi = ReactDOM.findDOMNode(dom);
                            }}
                            className={'sort-btn'}
                            style={{
                                cursor:'pointer',
                                marginRight:'6px',
                                marginLeft: '0px',
                                // display:'block',
                                // borderRadius: '3px',
                                // opacity: 1,
                                // background: '#FFFFFF',
                                // border: '1px solid #C6CCD7',
                                // width: '26px',
                                // height: '26px',
                                // textAlign: 'center'
                            }}
                        >
                            <i
                                className="iconfont icon-a-zu191x"
                                onClick={() => {}}
                            />
                        </span>
                    </div>
                </Tooltip>
            </Popover>
        );
    }
}
